import React, { useMemo, useState } from "react";

import ModalQ from "../../../components/TableBionovaQ/ModalQ/ModalQ";
import SelectQ from "../../../components/FormComponents/SelectQ/SelectQ";
import ErrorMessage from "../../../components/TableBionovaQ/ErrorMessage/ErrorMessage";
import InputQ from "../../../components/FormComponents/InputQ/InputQ";

import request from "../../../utils/request";

import styles from "./MaterialsTypesForm.module.css";
import { getSession } from "../../../utils/sessionHandler";
import { Checkbox, FormControlLabel, withStyles } from "@material-ui/core";
import CheckBoxQ from "../../../components/FormComponents/CheckBoxQ/CheckBoxQ";

const MaterialsTypesForm = ({
  formData,
  handleFormData,
  handleClose,
  open,
  locale,
  t,
  getMaterials,
  selectedSector,
  materialsType,
  methods,
}) => {
  const [error, setError] = useState("");
  const [validate, setValidate] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      setValidate(true);
      return;
    } else setValidate(false);

    try {
      const bodyRequest = {
        ...formData,
      };

      if (formData.id) {
        await request().put("/api/MaterialType", bodyRequest);
      } else {
        await request().post("/api/MaterialType", bodyRequest);
      }
      handleClose();
      setError("");
      setValidate(false);
      getMaterials();
    } catch (err) {
      setError(
        err.response?.data?.message || "Error al guardar el esterilizador."
      );
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    handleFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onClose = () => {
    handleClose();
    setError("");
    setValidate(false);
  };

  return (
    <ModalQ
      open={open}
      title={
        !formData.id
          ? t("NewMaterialType", locale) || "New Material Type"
          : t("EditMaterialType", locale) || "Edit Material Type"
      }
      handleClose={onClose}
    >
      {error && <ErrorMessage message={error} />}
      <div className={styles.container}>
        <div className={styles.inputGroup}>
          <InputQ
            containerWidth={"48%"}
            labelTop={true}
            label={t("NameSpan", locale) || "Name"}
            name="name"
            handleChange={handleInputChange}
            value={formData.name}
            required={true}
            validate={validate}
            leftMessage={true}
          />
          <InputQ
            containerWidth="48%"
            labelTop={true}
            label={t("Description", locale) || "Description"}
            name="description"
            handleChange={handleInputChange}
            value={formData.description}
          />
        </div>
        <div className={styles.inputGroup}>
          <InputQ
            containerWidth="48%"
            labelTop={true}
            label={t("ObservationSpan", locale) || "Observations"}
            name="observations"
            handleChange={handleInputChange}
            value={formData.observations}
          />
        </div>

        <button
          className={`${styles.button} ${styles.confirmButton}`}
          onClick={(e) => handleSubmit(e)}
        >
          Confirm
        </button>
      </div>
    </ModalQ>
  );
};

export default MaterialsTypesForm;
